import { MFAAuditLog } from '@organization/api/requests'
import { Table, TableColumnsType, TableProps } from 'antd'
import { SorterResult } from 'antd/es/table/interface'
import { useTranslation } from 'react-i18next'

import { getMFATableColumns } from './tableColumns'

type Props = {
  data?: MFAAuditLog[]
  triggerSort: (sorter: SorterResult<MFAAuditLog>) => void
  getSortedTableColumns: (
    columns: TableColumnsType<MFAAuditLog>
  ) => TableColumnsType<MFAAuditLog>
} & TableProps<MFAAuditLog>

export const LogMFATable = ({
  data,
  triggerSort,
  getSortedTableColumns,
  ...props
}: Props) => {
  const { t } = useTranslation()

  const columns = getSortedTableColumns(getMFATableColumns(t))

  return (
    <Table
      columns={columns}
      dataSource={data}
      rowKey="id"
      scroll={{ x: 'auto' }}
      onChange={(_, __, sorter) =>
        triggerSort(Array.isArray(sorter) ? sorter[0] : sorter)
      }
      {...props}
    />
  )
}
